import React, { useState, FunctionComponent } from "react";
import { useAuth } from '../../auth/Auth';
import { Link } from 'react-router-dom';
import { 
  Input, 
  Button, 
  Typography,
  Row,
  Col,
  Divider
} from 'antd';
import { 
  MailOutlined, 
  LockOutlined, 
  ArrowRightOutlined
} from '@ant-design/icons';
import MicrosoftAuth from '../MicrosoftAuth';
import './LoginComp.css';

const { Title, Text, Paragraph } = Typography;

const LogIn: FunctionComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const auth = useAuth();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(email, password);
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <Row justify="center" align="middle" className="login-row">
        <Col xs={22} sm={20} md={20} lg={20} xl={15} className="login-form-column">
          <div className="login-form-container">
            <div className="login-header text-center">
              <Title level={2} className="login-title">Welcome to Tommy</Title>
              <Paragraph className="login-subtitle">
                Log in to your account to continue using Tommy Agent
              </Paragraph>
            </div>
            
            <form className="login-form" onSubmit={submit}>
              <div className="form-input-group">
                <label htmlFor="email" className="input-label">Email</label>
                <Input
                  id="email"
                  size="large"
                  placeholder="Enter your email"
                  prefix={<MailOutlined className="input-icon" />}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  className="login-input"
                  disabled={loading}
                />
              </div>
              
              <div className="form-input-group">
                <label htmlFor="password" className="input-label">Password</label>
                <Input.Password
                  id="password"
                  size="large"
                  placeholder="Enter your password"
                  prefix={<LockOutlined className="input-icon" />}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  className="login-input"
                  disabled={loading}
                />
              </div>

              <div className="forgot-password-link">
                <Link to="/forgot-password" className="forgot-link">
                  Forgot your password?
                </Link>
              </div>
              
              <Button 
                type="primary" 
                htmlType="submit" 
                size="large" 
                className="login-button"
                icon={<ArrowRightOutlined />}
                loading={loading}
                disabled={loading}
              >
                Log In
              </Button>
              
              <Divider style={{ color: 'rgba(255, 255, 255, 0.5)', borderColor: 'rgba(255, 255, 255, 0.1)' }}>
                <span style={{ color: 'rgba(255, 255, 255, 0.5)' }}>OR</span>
              </Divider>
              
              <Row justify="center" style={{ width: '100%' }}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <MicrosoftAuth disabled={loading} />
                </div>
              </Row>

              <div className="signup-prompt text-center">
                <Text style={{ color: 'white'}}>Don't have an account? </Text>
                <a href="/signup" className="signup-link">Sign Up</a>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LogIn;